<p class="u-font-weight-500 u-font-size-20 u-margin-bottom-20">General Explanation:</p>
<div class="line-height-32 u-font-weight-400 u-font-size-21 default-weight-height">
  <mat-stepper
    [linear]="false"
    #stepper
    class="stepper-dialog__stepper">
    <mat-step
      *ngFor="let step of steps; let i = index"
      [stepControl]="getStepControl(i)"
      [label]="step.title">

      <section class="step-content">
        <h2 class="step-content__title">What is Body Composition?</h2>

        <p class="step-content__description">{{ step.description }}</p>

        <div class="step-content__video">
          <video
            controls
            class="step-content__video-player"
            [src]="step.videoUrl"
            aria-label="Body composition explanation video">
            Your browser does not support the video tag.
          </video>
        </div>

        <p class="step-content__info">
          Want to learn more? Click the red button below to continue.
        </p>

        <div class="step-content__navigation">
          <button
            mat-raised-button
            type="button"
            class="step-content__button step-content__button--back"
            (click)="onBack(stepper)"
            [disabled]="isFirstStep(stepper)">
            Back
          </button>

          <button
            *ngIf="!isLastStep(stepper)"
            mat-raised-button
            color="primary"
            type="button"
            class="step-content__button step-content__button--next"
            (click)="onNext(stepper)">
            Next
          </button>

          <button
            *ngIf="isLastStep(stepper)"
            mat-raised-button
            color="primary"
            type="button"
            class="step-content__button step-content__button--finish"
            (click)="onFinish()">
            Finish
          </button>
        </div>
      </section>
    </mat-step>
  </mat-stepper>
</div>
